import { useEffect,useRef } from 'react';
import { useLocation} from 'react-router-dom'
import './Our_Products.css';
import product1 from '../../assets/images/Product/Product1.jpeg'
import product2 from '../../assets/images/Product/Product2.png'
import product3 from '../../assets/images/Product/Product3.png'
import product4 from '../../assets/images/Product/Product4.png'
import product5 from '../../assets/images/Product/Product5.jpeg'
import product6 from '../../assets/images/Product/Product6.jpeg'
import product7 from '../../assets/images/Product/Product7.jpeg'
import product8 from '../../assets/images/Product/Product8.jpeg'
import product9 from '../../assets/images/Product/Product9.jpeg'
import product10 from '../../assets/images/Product/Product10.jpeg'
import product11 from '../../assets/images/Product/Product11.jpeg'
import product12 from '../../assets/images/Product/Product12.jpeg'

import OreoclavGM from '../../assets/images/OreoclavGM.jpg'
import oreocetamInj from '../../assets/images/Oreocetam Inj.jpg';
import OreocetamSpy from '../../assets/images/Oreocetam SYP.png'
import Oreoclav625 from '../../assets/images/oreoclav 625.png'
import ElsanacSP from '../../assets/images/Elsanac SP.png'
import MivalpOD from '../../assets/images/Mivalp OD.png'
import ElsanacMR from '../../assets/images/Elsanac MR.png'
import SepzoneSB from '../../assets/images/Sepzone SP Inj.png'
import Calsica from '../../assets/images/Calsica.png'
import PaxusCR from '../../assets/images/Paxus CR.png'
import Nexapenem1gm from '../../assets/images/Nexapenem.png'
import MemocephalSYP from '../../assets/images/MEmocephal SYP.png'
import elsanacInj from '../../assets/images/Elsanac Inj.jpg'
import elsanacGel from '../../assets/images/Elsanac Gel.png'
import calsicaQ10 from '../../assets/images/Calsica Q10.png'
import aos from 'aos';
import 'aos/dist/aos.css'

const Our_Products = () => {
  const section1 = useRef(null);
  const section2 = useRef(null);
  const section3 = useRef(null);
  const section4 = useRef(null);
  const section5 = useRef(null);
  const section6 = useRef(null);
  const section7 = useRef(null);
  const section8 = useRef(null);
  const section9 = useRef(null);
  const section10 = useRef(null);
  const section11 = useRef(null);
  const section12 = useRef(null);

  const { top } = useLocation();
  useEffect(() => {
    aos.init({ duration: 1000 });
    window.scrollTo(0,0);
  }, [top]);


  const scrollToSection = (section) => {
    section.current.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <>
    {/* Start Product Table  */}
    <div className="container py-lg-5">
      <div className="row pt-lg-0 pt-3">
        <div className="col-lg-3 col-md-3 col-6">
          <h6 className='text-center brand-logo'>Our Brands</h6>
        </div>
        <div className="col-lg-9 col-md-9 col-6">
          <h6 className='text-center product-name'>Product Name</h6>
        </div>
      </div><hr/>

      <div className="row ">
        <div className="col-lg-3 col-md-3 col-6">
         <img className='img-fluid product' onClick={() => scrollToSection(section1)} src={elsanacInj} alt="" />
        </div>
        <div className="col-lg-9 col-md-9 col-6 d-flex align-items-center justify-content-center">
         Elsanac-Inj
        </div>
      </div><hr/>
       <div className="row">
        <div className="col-lg-3 col-md-3 col-6">
         <img className='img-fluid product' onClick={() => scrollToSection(section2)} src={oreocetamInj} alt="" />
        </div>
        <div className="col-lg-9 col-md-9 col-6 d-flex align-items-center justify-content-center">
         Oreocetam-Inj
        </div>
      </div><hr/>
      <div className="row">
        <div className="col-lg-3 col-md-3 col-6">
         <img className='img-fluid product' onClick={() => scrollToSection(section3)} src={Oreoclav625} alt="" />
        </div>
        <div className="col-lg-9 col-md-9 col-6 d-flex align-items-center justify-content-center">
         Oreoclav-625
        </div>
      </div><hr/>
      <div className="row">
        <div className="col-lg-3 col-md-3 col-6">
         <img className='img-fluid product' onClick={() => scrollToSection(section4)} src={ElsanacSP} alt="" />
        </div>
        <div className="col-lg-9 col-md-9 col-6 d-flex align-items-center justify-content-center">
         Elsanac-SP
        </div>
      </div><hr/>

      <div className="row">
        <div className="col-lg-3 col-md-3 col-6">
         <img className='img-fluid product' onClick={() => scrollToSection(section5)} src={MivalpOD} alt="" />
        </div>
        <div className="col-lg-9 col-md-9 col-6 d-flex align-items-center justify-content-center">
         Mivalp-OD
        </div>
      </div><hr/>

      <div className="row">
        <div className="col-lg-3 col-md-3 col-6">
         <img className='img-fluid product' onClick={() => scrollToSection(section6)} src={ElsanacMR} alt="" />
        </div>
        <div className="col-lg-9 col-md-9 col-6 d-flex align-items-center justify-content-center">
         Elsanac-MR
        </div>
      </div><hr/>

      <div className="row">
        <div className="col-lg-3 col-md-3 col-6">
         <img className='img-fluid product' onClick={() => scrollToSection(section7)} src={SepzoneSB} alt="" />
        </div>
        <div className="col-lg-9 col-md-9 col-6 d-flex align-items-center justify-content-center">
         Sepzone SB - 1.5gm Inj
        </div>
      </div><hr/>

      <div className="row">
        <div className="col-lg-3 col-md-3 col-6">
         <img className='img-fluid product' onClick={() => scrollToSection(section8)} src={Calsica} alt="" />
        </div>
        <div className="col-lg-9 col-md-9 col-6 d-flex align-items-center justify-content-center">
         Calcica
        </div>
      </div><hr/>

      <div className="row">
        <div className="col-lg-3 col-md-3 col-6">
         <img className='img-fluid product' onClick={() => scrollToSection(section9)} src={PaxusCR} alt="" />
        </div>
        <div className="col-lg-9 col-md-9 col-6 d-flex align-items-center justify-content-center">
         Paxus-CR
        </div>
      </div><hr/>

      <div className="row">
        <div className="col-lg-3 col-md-3 col-6">
         <img className='img-fluid product' onClick={() => scrollToSection(section10)} src={Nexapenem1gm} alt="" />
        </div>
        <div className="col-lg-9 col-md-9 col-6 d-flex align-items-center justify-content-center">
         Nexapenem-1gm Inj
        </div>
      </div><hr/>

      <div className="row">
        <div className="col-lg-3 col-md-3 col-6">
         <img className='img-fluid product' onClick={() => scrollToSection(section11)} src={MemocephalSYP} alt="" />
        </div>
        <div className="col-lg-9 col-md-9 col-6 d-flex align-items-center justify-content-center">
         Memocephal-SYP
        </div>
      </div><hr/>

      <div className="row">
        <div className="col-lg-3 col-md-3 col-6">
         <img className='img-fluid product' onClick={() => scrollToSection(section12)} src={calsicaQ10} alt="" />
        </div>
        <div className="col-lg-9 col-md-9 col-6 d-flex align-items-center justify-content-center">
         CALSICA Q10
        </div>
      </div>
     

      </div><hr className='product-hr'/>
    {/*End Product Table  */}


         <div className="container py-lg-5 pt-3" ref={section1}>
        <div className="row py-3">
          <h6 className='product-heading' data-aos="zoom-in">In the Management of Pain and Inflammation Associated with Arthritis, Gout, Postoperative Pain, Renal Colic and Dysmenorrhea</h6>
        </div>

        <div className="row mb-3">
          <img className='img-fluid product-img' data-aos="zoom-in" src={elsanacInj} alt="" />
        </div>
        <div className="row">
          <div className='second-heading' data-aos="zoom-in">
            <span>Control the Uncontrolled Pain*</span>
          </div>

        </div>

        <div className="row change-column-direction ">
          <div className="col-lg-6 col-md-6 col-sm-6 mb-3 ">
            <div className="content" data-aos="zoom-in">
              <p><span>Swift Pain Relief: </span>Diclofenac Injection delivers quick relief, easing pain rapidly.</p>
              <p><span>Precision Inflammation Control: </span>Targets and controls inflammation with precision, addressing pain at its source.</p>
              <p><span>Versatile Pain Management: </span> Effectively manages pain from diverse sources, including postoperative discomfort and renal colic.</p>
              <p><span>Fast-Acting Comfort: </span>Rapid onset of action ensures prompt comfort, aiding a more tolerable recovery.</p>
              <p><span>Trusted Postoperative Aid: </span>A reliable solution for postoperative pain relief, enhancing the recovery experience.</p>
              <p><span>Holistic Pain Control: </span>Prioritizing patient well-being, it not only alleviates pain but also addresses the underlying inflammation for a comprehensive approach to pain management.</p>
              <div>
                <div className="row">
                  <div className="col-4"><span>Also Avaiable:</span></div>
                  <div className="col-8"><img className='img-fluid' src={elsanacGel} alt="" /></div>
                </div>  
              </div>
              
            </div>
          </div>
          <div className="col-lg-6 col-md-6 col-sm-6 d-flex align-items-center" data-aos="zoom-in">
            <img className='img-fluid doctor-img' src={product1} alt="" />
          </div>
        </div>
        </div><hr className='product-hr'/>

      <div className='container py-lg-5 pt-3' ref={section2}>

        <div className="row mb-3 ">
          <h6 className='product-heading' data-aos="zoom-in">Complete the Management of the Lost Cognitive Functions of Brain </h6>
        </div>

        <div className="row mb-3">
          <div className="col-lg-6 mb-3">
            <img className='img-fluid' data-aos="zoom-in" src={oreocetamInj} alt="" />
          </div>
          <div className="col-lg-6">
            <img className='img-fluid' data-aos="zoom-in" src={OreocetamSpy} alt="" />
          </div>
        </div>

        <div className="row d-flex justify-content-center">
          <div className='second-heading' data-aos="zoom-in">
            <span>Cognitive recovery complementor*</span>
          </div>

        </div>

        <div className='row py-3'>
          <div className={`col-lg-6 col-md-6 col-sm-6 mb-3 d-flex align-items-center`}>
            <img className='img-fluid doctor-img' data-aos="zoom-in" src={product2} alt="" />
          </div>
          <div className={`col-lg-6 col-md-6 col-sm-6 mb-3`} >
            <div className="content" data-aos="zoom-in">
              <p><span>Cognitive Supportor: </span>Piracetam enhances mental clarity and focus.</p>
              <p><span>Neurotransmitter Boost: </span>Piracetam supports neurotransmitter synthesis, crucial for memory and learning.</p>
              <p><span>Memory Agility (Piracetam): </span>Piracetam enhances memory and cognitive capabilities, promoting neuronal plasticity.</p>
              <p><span>Brain Energy Support: </span>Piracetam maintains optimal brain energy levels, fostering mental alertness.</p>
              <p><span>Synergstic Memory Aid: </span>Piracetam synergize for improved memory function</p>
              <p><span>Personalized Cognitive Wellness: </span>Prioritizing patients,this combination offers a tailored approch to cognitive enhancement and overall mental well-being.</p>
            </div>
          </div>
        </div>
      </div><hr className='product-hr'/>


      <div className="container py-lg-5 pt-3" ref={section3}>
        <div className="row mb-3">
          <h6 className='product-heading' data-aos="zoom-in">In the treatment of RTI,UTI, SSTI, & other bacterial infections caused by susceptible strains</h6>
        </div>

        <div className="row mb-3">
          <img className='img-fluid product-img' data-aos="zoom-in" src={Oreoclav625} alt="" />

        </div>
        <div className="row d-flex justify-content-center py-3">
          <div className='second-heading' data-aos="zoom-in">
            <span>The unmatched ultimate Duo power*</span>
          </div>

        </div>

        <div className="row change-column-direction">
          <div className={`col-lg-6 col-md-6 col-sm-6 mb-3 `} data-aos="zoom-in">
            <div className="content">
              <p><span>Versatile Infection Management: </span>Tailored for respiratory, urinary, and skin infections, it provides comprehensive coverage with precision.</p>
              <p><span>Optimal Dosage Control: </span>Calibrated dosage ensures accurate medication, optimizing therapeutic benefits while minimizing resistance risk.</p>
              <p><span>Trusted Antibiotic Legacy: </span>Built on Amoxicillin's legacy, it maintains reliability, offering effective bacterial infection management.</p>
              <p><span>Patient-Centric Wellness: </span>Designed with patients in mind,prioritizing both efficacy and safety for an improved quality of life.</p>
              <img className='img-fluid' src={OreoclavGM} alt="" />
            
            </div>

          </div>
          <div className={`col-lg-6 col-md-6 col-sm-6 mb-3`} data-aos="zoom-in">
            <img className='img-fluid doctor-img' src={product3} alt="" />
            <div className="content img-bottom-content">
              <p><span>Dual-Action Potency: </span>Amoxicillin and Potassium Clavulanate combine for a potent dual approach, effectively treating a range of bacterial infections.</p>
              <p><span>Resilient Resistance Combat: </span>Enhanced by Clavulanate, it conquers resistant strains, ensuring heightened efficacy against diverse infections.</p>
            </div>
          </div>
        </div>

      </div><hr className='product-hr'/>

      <div className="container py-lg-5 pt-3" ref={section4}>
        <div className="row">
          <h6 className='product-heading' data-aos="zoom-in">In the Comprehensive Management of Pain, Fever and Inflammation</h6>
        </div>

        <div className="row mb-3">
          <img className='img-fluid product-img' data-aos="zoom-in" src={ElsanacSP} alt="" />
        </div>
        <div className="row d-flex justify-content-center py-3">
          <div className='second-heading' data-aos="zoom-in">
            <span>Relief the pain with maximum gain*</span>
          </div>

        </div>

        <div className="row">
          <div className="col-lg-6 col-md-6 col-sm-6 mb-3 d-flex align-items-center" data-aos="zoom-in">
            <img className='img-fluid doctor-img' src={product4} alt="" />
          </div>
          <div className="col-lg-6 col-md-6 col-sm-6 mb-3 " data-aos="zoom-in">
            <div className="content">
              <p><span>Triple-Threat Pain Relief: </span>Aceclofenac, Serratiopeptidase, and Paraceta-mol form a powerful trio, addressing pain with anti-inflammatory, enzymatic, and analgesic actions.</p>
              <p><span>Swift Inflammation Control: </span>Aceclofenac's anti-inflammatory prowess swiftly manages inflammation, reducing pain and promoting comfort.</p>
              <p><span>Enzymatic Healing Touch (Serratiopeptidase 15mg): </span>Serratiopeptidase, an enzyme with anti-inflammatory properties, aids in accelerating tissue repair and reducing swelling.</p>
              <p><span>Analgesic Harmony (Paracetamol 325mg): </span>Paracetamol contributes to the analgesic effect, ensuring a harmonious balance in pain relief without compromising safety.</p>
              <p><span>Muscular Freedom: </span>Serratiopeptidase supports muscle recovery, comple- menting Aceclofenac's anti-inflammatory action for holistic pain relief.</p>
              <p><span>Patient-Centric Wellness: </span> Crafted for patient-centric care, this combination prioritizes effective and well-rounded pain management, enhancing the overall quality of life.</p>
            </div>
          </div>

        </div>

      </div><hr className='product-hr'/>

      <div className="container py-lg-5 pt-3" ref={section5}>
        <div className="row">
          <h6 className='product-heading' data-aos="zoom-in">In the Comprehensive Management of Migraine,Epilepsy,& Bipolar Disorder</h6>
        </div>

        <div className="row">
          <img className='img-fluid product-img' data-aos="zoom-in" src={MivalpOD} alt="" />
        </div>
        <div className="row d-flex justify-content-center py-3">
          <div className='second-heading' data-aos="zoom-in">
            <span>Rise or fall, once OD for all*</span>
          </div>

        </div>

        <div className="row change-column-direction ">
          <div className="col-lg-6 col-md-6 col-sm-6 mb-3 " data-aos="zoom-in">
            <div className="content">
              <p><span>Mood Stability & Bipolar Support: </span>Divalproex Sodium ER (250/500mg) excels in stabilizing mood, offering crucial support for bipolar disorder management.</p>
              <p><span>Epilepsy Control: </span>A reliable antiepileptic, providing effective seizure control for enhanced patient safety.</p>
              <p><span>Extended-Release Assurance: </span>Ensuring a controlled release, the extended-release formulation optimizes therapeutic benefits with simplified dosing.</p>
              <p><span>Migraine Prevention: </span>Valuable in preventing migraines, reducing frequency and severity for improved daily life.</p>
              <p><span>Personalized Dosage Options (250/500mg): </span>Patient-friendly options, with 250mg and 500mg doses, cater to individual treatment needs.</p>
              <p><span>Holistic Wellness Partner: </span>Tailored for patients, promoting overall wellness by addressing various neurological and mood disorders effectively.</p>
            </div>
          </div>
          <div className="col-lg-6 col-md-6 col-sm-6 d-flex align-items-center " data-aos="zoom-in">
            <img className='img-fluid doctor-img' src={product5} alt="" />
          </div>
        </div>
      </div><hr className='product-hr'/>

      <div className="container py-lg-5 pt-3" ref={section6}>

        <div className="row">
          <h6 className='product-heading' data-aos="zoom-in">In the Comprehensive Management of Pain, Muscle Relaxant and Inflammation</h6>
        </div>

        <div className="row">
          <img className='img-fluid product-img' data-aos="zoom-in" src={ElsanacMR} alt="" />
        </div>

        <div className="row d-flex justify-content-center py-3">
          <div className='second-heading' data-aos="zoom-in">
            <span>Realx & Relief at One Go *</span>
          </div>
        </div>

        <div className="row">
          <div className="col-lg-6 d-flex align-items-center">
            <img className='img-fluid doctor-img' data-aos="zoom-in" src={product6} alt="" />
          </div>
          <div className="col-lg-6">
            <div className="content" data-aos="zoom-in">
              <p><span>Triple Action Pain Relief: </span>Aceclofenac provides anti-inflammatory relief, Chlorzoxazone offers muscle relaxation, and Paracetamol alleviates pain, creating a comprehensive solution for various types of discomfort.</p>
              <p><span>Fast and Effective: </span>Experience quick and efficient relief with the combined strength of Aceclofenac, Chlorzoxazone, and Paracetamol, targeting pain at its source.</p>
              <p><span>Muscle Relaxation Mastery: </span>Chlorzoxazone's muscle relaxant properties enhance the trio, addressing muscle-related pain and promoting a sense of ease.</p>
              <p><span>Inflammation Control: </span>Aceclofenac's anti-inflammatory prowess aids in managing inflammation, contributing to the overall reduction of pain and discomfort.</p>
              <p><span>Analgesic Harmony: </span> Paracetamol's analgesic effect complements the formulation, ensuring a harmonious balance for effective pain relief without compromising safety.</p>
              <p><span>Patient-Centric Wellness: </span>Tailored for patient-centric care, this combination provides a well-rounded approach to pain management, improving overall quality of life.</p>
            </div>
          </div>
        </div>
      </div><hr className='product-hr'/>

      <div className="container py-lg-5 pt-3" ref={section7}>
        <div className="row">
          <h6 className='product-heading' data-aos="zoom-in">For the Treatment of Respiratory, Skin, Intra-abdominal, Urinary Tract and Gynecological Bacterial Infections along with Surgical Prophylaxis.</h6>
        </div>
        <div className="row">
          <img className='img-fluid product-img' data-aos="zoom-in" src={SepzoneSB} alt="" />
        </div>

        <div className="row d-flex justify-content-center py-3">
          <div className='second-heading' data-aos="zoom-in">
            <span>Where Versatility Meets Strength*</span>
          </div>
        </div>


        <div className="row change-column-direction">
          <div className="col-lg-6">
            <div className="content" data-aos="zoom-in">
              <p><span>Dual Strength Defense: </span>Cefoperazone-Sulbactam combines potent antibacterial action with beta-lactamase inhibition for versatile infection control.</p>
              <p><span>Infection Versatility: </span> Efficacious against a range of infections, from respiratory to gynecological, providing versatile treatment.</p>
              <p><span>Targeted Precision: </span>Precise targeting ensures effective bacterial eradication, optimizing therapeutic outcomes.</p>
              <p><span>Prophylaxis Assurance: </span>Trusted for surgical prophylaxis, preventing infections and ensuring postoperative recovery.</p>
              <p><span>Rapid Response: </span> Swift and reliable, it accelerates recovery, addressing diverse bacterial infections.</p>
              <p><span>Simplified Infection Management: </span>Streamlines treatment with a potent injection, managing various infections effectively.</p>
            </div>
          </div>
          <div className="col-lg-6 d-flex align-items-center">
            <img className='img-fluid doctor-img' data-aos="zoom-in" src={product7} alt="" />
          </div>
        </div>
      </div><hr className='product-hr'/>

      <div className="container py-lg-5 pt-3" ref={section8}>
        <div className="row">
          <h6 className='product-heading' data-aos="zoom-in">In the Comprehensive Management of all Calcium Deficient Disorders</h6>
        </div>
        <div className="row">
          <img className='img-fluid product-img' data-aos="zoom-in" src={Calsica} alt="" />
        </div>

        <div className="row d-flex justify-content-center py-3">
          <div className='second-heading' data-aos="zoom-in">
            <span>The Strong Pillar For Physical Stability*</span>
          </div>
        </div>

        <div className="row">
          <div className="col-lg-6 d-flex align-items-center">
            <img className='img-fluid doctor-img' data-aos="zoom-in" src={product8} alt="" />
          </div>
          <div className="col-lg-6">
            <div className="content" data-aos="zoom-in">
              <p><span>Calcium Citrate (1000mg): </span>Essential for bone health, Calcium Citrate provides a bioavailable source of calcium, supporting bone strength and density, while also aiding in muscle function.</p>
              <p><span>Magnesium (100mg): </span>Complementing calcium, Magnesium contributes to muscle and nerve function, cardiovascular health, and supports the absorption of calcium for overall musculoskeletal well-being.</p>
              <p><span>Vitamin D3 (250 I.U): </span>Enhancing calcium absorption, Vitamin D3 is crucial for bone health, immune system modulation, and plays a vital role in preventing deficiencies associated with various health conditions.</p>
              <p><span>Zinc (4mg): </span>Acting as a trace element, Zinc contributes to immune function, wound healing, and supports the overall growth and maintenance of tissues, providing a holistic approach to well-rounded health.</p>
              <p><span>Synergistic Nutrient Interplay: </span>The synergistic combination of Calcium, Magnesium, Vitamin D3, and Zinc optimizes their roles, ensuring a balanced and comprehensive approach to bone health, immune support, and overall vitality.</p>
              <p><span>Comprehensive Patient Care: </span> Tailored for comprehensive patient care, this combination addresses multiple facets of health, making it a valuable addition to therapeutic strategies promoting overall well-being.</p>
            </div>
          </div>
        </div>
      </div><hr className='product-hr'/>

      <div className="container py-lg-5 pt-3" ref={section9}>
        <div className="row">
          <h6 className="product-heading" data-aos="zoom-in">
            In the Comprehensive Management of Major Depressive Disorder, Obsessive-Compulsive Disorder, Panic Disorder, Social Anxiety Disorder, Generalized Anxiety Disorder and Post-Traumatic Stress Disorder
          </h6>
        </div>
        <div className="row">
          <img className='img-fluid product-img' data-aos="zoom-in" src={PaxusCR} alt="" />
        </div>

        <div className="row d-flex justify-content-center py-3">
          <div className='second-heading' data-aos="zoom-in">
            <span>For Balanced Mind & Controlled Body*</span>
          </div>
        </div>

        <div className="row change-column-direction">
          <div className="col-lg-6">
            <div className="content" data-aos="zoom-in">
              <p><span>Tailored Depression Relief: </span> Paroxetine CR addresses major depressive disorder with controlled-release precision, offering sustained relief.</p>
              <p><span>OCD Mastery:</span> Aiding in the management of obsessive-compulsive disorder, Paroxetine CR provides a steady approach to alleviating intrusive thoughts.</p>
              <p><span>Panic Disorder Tamed: </span> Designed to ease panic attacks, Paroxetine CR stands as a reliable ally in the treatment of panic disorder.</p>
              <p><span>Social Confidence Unleashed: </span>Tailored for social anxiety disorder, Paroxetine CR empowers individuals to navigate social interactions with newfound confidence.</p>
              <p><span>Generalized Tranquility: </span>In the realm of generalized anxiety disorder, Paroxetine CR delivers a steady release of calm, easing persistent worry.</p>
              <p><span>PTSD Supportive Care: </span>Paroxetine CR extends its therapeutic embrace to post-traumatic stress disorder, aiding individuals on their journey to healing and resilience.</p>
            </div>
          </div>
          <div className="col-lg-6 d-flex align-items-center">
            <img className='img-fluid doctor-img' data-aos="zoom-in" src={product9} alt="" />
          </div>
        </div>
      </div><hr className='product-hr'/>

      <div className="container py-lg-5 pt-3" ref={section10}>
        <div className="row">
          <h6 className='product-heading px-3' data-aos="zoom-in">For the Treatment of Intra-abdominal Infections, Skin and Soft Tissue Infections, Bacterial Meningitis, Pneumonia, Urinary Tract Infections, Gynecological Infections and Septicemia</h6>
        </div>
        <div className="row">
          <img className='img-fluid product-img' data-aos="zoom-in" src={Nexapenem1gm} alt="" />
        </div>
        <div className="row d-flex justify-content-center py-3">
          <div className='second-heading' data-aos="zoom-in">
            <span>Accuracy in Beating Multiple Origin Infections*</span>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-6 d-flex align-items-center">
            <img className='img-fluid doctor-img' data-aos="zoom-in" src={product10} alt="" />
          </div>
          <div className="col-lg-6">
            <div className="content" data-aos="zoom-in">
              <p><span>Precision Infection Control: </span> Meropenem precisely targets and eliminates a broad spectrum of bacterial infections.</p>
              <p><span>Swift and Reliable Relief: </span>Ensures rapid and reliable efficacy against diverse infections, providing quick relief.</p>
              <p><span>Versatile Solution: </span>Comprehensive coverage from intra-abdominal to gynecological infections, simplifying treatment.</p>
              <p><span>Trusted in Critical Cases: </span>Demonstrates efficacy in severe conditions like meningitis and septicemia, a reliable choice.</p>
              <p><span>Potent Broad-spectrum Defense: </span> Exhibits powerful antibacterial action, making it versatile for a wide range of infections.</p>
              <p><span>Streamlined Therapeutic Approach: </span>Simplifies treatment by effectively managing various infections with a single, potent injection.</p>

            </div>
          </div>
        </div>
      </div><hr className='product-hr'/>

      <div className="container py-lg-5 pt-3" ref={section11}>
        <div className="row">
          <h6 className='product-heading px-2' data-aos="zoom-in">
            For Enhance the Cognitive Function & Alleviating Stress/Anxiety
          </h6>
        </div>
        <div className="row">
          <img className='img-fluid product-img' data-aos="zoom-in" src={MemocephalSYP} alt="" />
        </div>
        <div className="row d-flex justify-content-center py-3">
          <div className='second-heading' data-aos="zoom-in">
            <span>Elevate Memory, Erase Stress with Every Dose*</span>
          </div>
        </div>
        <div className="row change-column-direction">
          <div className="col-lg-6">
            <div className="row py-3">
              <div className="col-lg-4">
                <div className='btn btn-primary mb-3 w-100' data-aos="zoom-in">Memory Brilliance</div>
                <div className='btn btn-primary mb-3 w-100' data-aos="zoom-in">Stress Serenity</div>
                <div className='btn btn-primary mb-3 w-100' data-aos="zoom-in">Natural Harmony</div>
                <div className='btn btn-primary mb-3 w-100' data-aos="zoom-in">Relax,Sip,Unwid</div>
                <div className='btn btn-primary mb-3 w-100' data-aos="zoom-in">Your Patients Wellness, Your way</div>

              </div>
              <div className="col-lg-8 " data-aos="zoom-in">

                <table className='table-container'>
                  <thead className='table-heading'>
                    <tr>
                      <th colSpan="3">Each 10 ml contains extract of:</th>
                    </tr>
                  </thead>
                  <tbody className='table-body'>
                    <tr>
                      <td>Ashwagandha</td>
                      <td>Withania somnsfera</td>
                      <td>1500mg</td>
                    </tr>
                    <tr>
                      <td>Shankhpushpi</td>
                      <td>Convolvulus pluricaulis</td>
                      <td>1000mg</td>
                    </tr>
                    <tr>
                      <td>Jyotishmati</td>
                      <td>Celastrus Paniculatus</td>
                      <td>1000mg</td>
                    </tr>
                    <tr>
                      <td>Jatamansi</td>
                      <td>Nardostachys jatemensi</td>
                      <td>1000mg</td>
                    </tr>
                    <tr>
                      <td>Brahmi</td>
                      <td>Bacopa monnieri</td>
                      <td>1500mg</td>
                    </tr>
                    <tr>
                      <td>Mulethi</td>
                      <td>Glycyrrhiza glabra</td>
                      <td>750mg</td>
                    </tr>
                    <tr>
                      <td>Giloy</td>
                      <td>Tmospora cordifolia</td>
                      <td>1000mg</td>
                    </tr>
                    <tr>
                      <td>Vacha</td>
                      <td>Acores calamus</td>
                      <td>500mg</td>
                    </tr>
                    <tr>
                      <td>Excipients</td>
                      <td></td>
                      <td>q.s.</td>
                    </tr>
                  </tbody>
                </table>


              </div>
            </div>
          </div>
          <div className="col-lg-6 d-flex align-items-center">
            <img className='img-fluid doctor-img' data-aos="zoom-in" src={product11} alt="" />
          </div>
        </div>
      </div><hr className='product-hr'/>

      <div className="container py-lg-5 pt-3" ref={section12}>
        <div className="row">
          <h6 className='product-heading px-3' data-aos="zoom-in">Ensure Advanced Support for Vitality, Immunity & Cellular Protection</h6>
        </div>
        <div className="row">
          <img className='img-fluid product-img' data-aos="zoom-in" src={calsicaQ10} alt="" />
        </div>
        <div className="row d-flex justify-content-center">
          <div className='second-heading' data-aos="zoom-in">
            <span>Empower Health, Energize Life</span>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-6">
          <div className="content" data-aos="zoom-in">
              <p><span>Comprehensive Cellular Protection: </span>L-Carnosine, CoQ10, and L-Glutathione deliver potent antioxidant and cellular repair support, enhancing longevity and vitality.</p>
              <p><span>Brain & Heart Health Synergy: </span>DHA and Vitamin B complex (B6, B12) aid cognitive function and cardiovascular health, keeping both mind and heart energized.</p>
              <p><span>Immunity Boost with Enhanced Resilience: </span>Zinc Citrate, NAC, and Selenium work together to fortify immune defenses, while Ashwagandha helps manage stress levels, promoting overall resilience.</p>
             

            </div>
          </div>

          <div className="col-lg-6">
            <div className="content" data-aos="zoom-in">
              <p><span>Bone Strength & Mobility: </span> Vitamin D3, Magnesium Glycinate, and Vitamin K2 team up to strengthen bones, supporting mobility and quality of life.</p>
              <p><span>Superior Bioavailability and Gentle on Stomach: </span>Iron Bisglycinate and Methylfolate provide high absorption with minimal gastrointestinal discomfort, optimizing efficacy.</p>
              <p><span>Conclusion: </span><b>A complete daily solution designed to meet the needs of modern health and active lifestyles, ensuring optimal vitality, immunity, and well-being.</b> </p>
              

            </div>
          </div>
        </div>
      </div><hr className='product-hr'/>

      <div className="container-fluid pt-3 gx-0">
        <div className="row gx-0">
         <div className="col-12 gx-0">
         <img className='img-fluid' data-aos="zoom-in" src={product12} alt="" />
         </div>
        </div>
      </div>
    </>
  )
}

export default Our_Products
